import React, { useContext } from 'react'
import { AlertCircle } from 'react-feather'
import { Text } from '@pancakeswap-libs/uikit'
import styled, { ThemeContext } from 'styled-components'
import { AutoColumn } from '../Column'
import { AutoRow } from '../Row'

const RowNoFlex = styled(AutoRow)`
  flex-wrap: nowrap;
`

export default function WalletErrorPopup({ message }: { message: string }) {
  const theme = useContext(ThemeContext)

  return (
    <RowNoFlex>
      <div style={{ paddingRight: 16 }}>
        <AlertCircle color={theme.colors.failure} size={24} />
      </div>
      <AutoColumn gap="8px">
        <Text bold>Wallet connection failed</Text>
        <Text fontSize="14px" color="textSubtle">
          {message}
        </Text>
      </AutoColumn>
    </RowNoFlex>
  )
}
